import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom'
import { Translate } from "react-localize-redux";
import './styles.scss';

const mainLink = 'www.myhellohello.com';

const facebookLogo = 'https://s3-eu-west-1.amazonaws.com/myhellohellostatic/media/users/social_media_icons/facebook-logo.png';
const messengerLogo = 'https://s3-eu-west-1.amazonaws.com/myhellohellostatic/media/users/social_media_icons/messenger-icon.png';
const linkedInLogo = 'https://s3-eu-west-1.amazonaws.com/myhellohellostatic/media/users/social_media_icons/linkedin-logo.png';

// Text for sharing on LinkedIn
// TODO: Should update to move some place more central for controlling this logic
const linkedInText = 'Please join me on myHelloHello! The only worldwide contact directory!';

export class ShareCardPage extends React.Component {
  render() {
    const profileLink = `${mainLink}/contact-card/${this.props.slug || ''}`;

    const socialItems = [
      {
        message: <Translate id="PostonFacebookwall" />,
        link: `https://www.facebook.com/sharer/sharer.php?u=https%3A//${profileLink}`,
        img: facebookLogo,
      },
      {
        message: <Translate id="FacebookMessenger" />,
        link: `https://www.facebook.com/sharer/sharer.php?u=https%3A//${profileLink}`,
        img: messengerLogo,
      },
      {
        message:<Translate id="PosttoyourLinkedIn" />,
        link: `https://www.linkedin.com/shareArticle?mini=true&url=https%3A//${profileLink}&text=${linkedInText}`,
        img: linkedInLogo,
      }
    ];

    return (
      <div
        id="page-container"
        className="row align-items-center justify-content-center">

        <div className="container">
          <div className="row">
            <div className="col text-center">
              <h3 id="share-card-title">
                <Translate id="SendContactCard" />
              </h3>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 text-center">
              <p><Translate id="ShareInfoText" /></p>
            </div>
          </div>

          <div className="row align-items-center justify-content-center">
            <div className="col-lg-5">
              <ul className="list-group">
                {socialItems.map(item =>
                  <li
                    className="list-group-item share-list-item"
                    onClick={()=> window.open(item.link, "_blank")}
                  >
                    <div className="row">
                      <div className="col-10">{item.message}</div>
                      <div className="col-2"><img src={item.img} className="social-share-img"/></div>
                    </div>
                  </li>
                )}

                <li className="list-group-item share-list-item">
                  Use Custom link
                  <input id="custom-link-input" type="text" value={`https://${profileLink}`}/>
                </li>
              </ul>
            </div>
          </div>
          <br/>
          <div className="row">
            <div className="col text-center">
              <NavLink
                to="/"
                className="btn btn-primary"
              >
               <Translate id="Close" />
              </NavLink>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToprops = ({ profile }) => ({
  slug: profile.profile.slug,
});

export default connect(mapStateToprops)(ShareCardPage);



// WEBPACK FOOTER //
// ./src/components/pages/ShareCardPage/ShareCardPage.jsx